import { useCallback } from "react";
import { vibeTypeToText } from "../../lib/vibe-type-to-text";
import { VibeType } from "../../types/VibeType";
import "./VibeSelector.scss";

interface VibeSelectorProps {
  disabled?: boolean;
  value: VibeType[];
  onChange: (vibes: VibeType[]) => void;
}

export default function VibeSelector({
  value: vibeValues,
  onChange,
  disabled,
}: VibeSelectorProps) {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const vibeEnum = value as VibeType;
      const newVibes = [...vibeValues];
      if (vibeValues.includes(vibeEnum)) {
        newVibes.splice(newVibes.indexOf(vibeEnum), 1);
      } else {
        newVibes.push(vibeEnum);
      }
      onChange(newVibes);
    },
    [vibeValues, onChange]
  );

  return (
    <div className="vibe-selector">
      {Object.values(VibeType).map((vibe) => (
        <div key={vibe} className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="checkbox"
            id={`vibe-${vibe}`}
            name="vibes"
            value={vibe}
            checked={vibeValues?.includes(vibe) || false}
            onChange={handleChange}
            disabled={disabled}
          />
          <label className="form-check-label" htmlFor={`vibe-${vibe}`}>
            {vibeTypeToText(vibe)}
          </label>
        </div>
      ))}
    </div>
  );
}
